import { useState } from "react";
import { Bug, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export async function sendErrorReport({ message, details = "", contact_email = null }) {
  await api.post("/report-error", {
    message, details, contact_email,
    page: window.location.pathname + window.location.search,
    user_agent: navigator.userAgent,
  });
}

export function ReportErrorDialog({ open, onClose, details = "" }) {
  const { user } = useAuth();
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await sendErrorReport({ message, details, contact_email: !user && email ? email : null });
      toast.success("Danke! Deine Meldung wurde an das itzPlay-Team gesendet 💌");
      setMessage(""); onClose();
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-3xl max-w-md" data-testid="report-error-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Fehler melden</DialogTitle>
          <DialogDescription>Beschreibe kurz, was nicht funktioniert hat. Deine Meldung geht direkt per E-Mail an uns. Seite und Gerät werden automatisch mitgeschickt.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <Textarea data-testid="report-error-message" required minLength={5} maxLength={2000} rows={5} className="rounded-xl" placeholder="Was ist passiert? Was hast du gerade gemacht?" value={message} onChange={(e) => setMessage(e.target.value)} />
          {!user && <Input data-testid="report-error-email" type="email" className="rounded-xl" placeholder="Deine E-Mail für Rückfragen (optional)" value={email} onChange={(e) => setEmail(e.target.value)} />}
          <button type="submit" disabled={busy || message.trim().length < 5} data-testid="report-error-submit" className="w-full h-12 rounded-full pink-gradient text-white font-bold flex items-center justify-center gap-2 disabled:opacity-50">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Meldung senden
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function ReportErrorButton({ className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="report-error-btn" className={`inline-flex items-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-rose-600 transition-colors ${className}`}>
        <Bug className="w-3.5 h-3.5" /> Fehler melden
      </button>
      <ReportErrorDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
